import { ReactNode } from 'react';
import styled from 'styled-components';
import { Dialog } from '@progress/kendo-react-dialogs';
import React from 'react';
import { MainLoader } from '../SkeletonLoader/MainLoader';

interface CustomPopupProps {
  title?: string;
  children?: ReactNode;
  setVisible?: (visible: boolean) => void;
  visible?: boolean;
  footer?: boolean;
  footerChildren?: ReactNode;
  className?: string;
  closeToggle?: () => void;
  isMainLoader?: boolean;
}
export const CustomPopup = ({
  className,
  title,
  children,
  footer,
  footerChildren,
  visible,
  setVisible,
  closeToggle,
  isMainLoader,
}: CustomPopupProps) => {
  const toggleDialog = () => {
    closeToggle?.();
    setVisible?.(!visible);
  };
  return (
    <>
      {isMainLoader && <MainLoader />}
      {visible && (
        <StyledDialog
          title={title}
          onClose={toggleDialog}
          className={className}
        >
          {children}
          {footer && <>{footerChildren}</>}
        </StyledDialog>
      )}
    </>
  );
};
const StyledDialog = styled(({ ...props }) => <Dialog {...props} />)`
  &.payment-popup {
    .k-dialog {
      width: 500px !important;
      @media (min-width: 300px) and (max-width: 400px) {
        width: 325px !important;
      }
      @media (min-width: 400px) and (max-width: 460px) {
        width: 400px !important;
      }
      @media (min-width: 460px) and (max-width: 540px) {
        width: 425px !important;
      }
      .k-dialog-titlebar {
        border-width: 0 0 0;
        .k-dialog-title {
          font-size: 12px !important;
          font-weight: 600 !important;
        }
      }
    }
  }
  background: ${p => p.theme.customPopupOverlayBg};
  height: 100%;
  .k-window-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: end;
  }
  .k-window-title {
    font-size: 22px;
    @media (min-width: 992px) and (max-width: 1023px) {
      font-size: 11.73px;
    }
    @media (min-width: 1024px) and (max-width: 1279px) {
      font-size: 14.65px;
    }
    @media (min-width: 1280px) and (max-width: 1365px) {
      font-size: 15.58px;
    }
    @media (min-width: 1366px) and (max-width: 1439px) {
      font-size: 16.49px;
    }
    @media (min-width: 1440px) and (max-width: 1600px) {
      font-size: 18.33px;
    }
  }
  .k-dialog {
    background: ${p => p.theme.customPopupBg};
    border-radius: 10px;
    max-height: calc(100vh - 50px);
  }
`;
